import { Refine, ResourceProps } from '@refinedev/core';
import { DataProviders } from '@refinedev/core/dist/contexts/data/types';
import { RefineSnackbarProvider, useNotificationProvider } from '@refinedev/mui';
import routerProvider from '@refinedev/react-router-v6';
import refineDataProvider from '@refinedev/simple-rest';
import { APIProvider } from '@vis.gl/react-google-maps';
import { ReactNode } from 'react';

import { createDataProvider } from '../../utils/createDataProvider/createDataProvider';

const GOOGLE_MAPS_API_KEY = 'AIzaSyACa__1i4lx3lWZGWu6lJFFcY7TH7qDfxI';

export const Admin = ({
  children,
  resources,
  dataProviders,
}: {
  children: ReactNode;
  resources?: ResourceProps[];
  dataProviders?: DataProviders;
}) => {
  return (
    <RefineSnackbarProvider
      anchorOrigin={{
        horizontal: 'left',
        vertical: 'bottom',
      }}
    >
      <APIProvider apiKey={GOOGLE_MAPS_API_KEY}>
        <Refine
          dataProvider={{
            accounts: createDataProvider('accounts'),
            deals: refineDataProvider('/api/deals/v1'),
            default: createDataProvider('root'),
            grades: createDataProvider('grades'),
            inspections: createDataProvider('inspections'),
            logistics: createDataProvider('logistics'),
            materials: createDataProvider('materials'),
            orders: createDataProvider('orders'),
            post_deal: createDataProvider('post-deal'),
            trade: createDataProvider('trade'),
            transportCosts: createDataProvider('transport-prices'),
            ...dataProviders,
          }}
          routerProvider={routerProvider}
          notificationProvider={useNotificationProvider}
          resources={resources}
        >
          {children}
        </Refine>
      </APIProvider>
    </RefineSnackbarProvider>
  );
};
